import styled from 'styled-components';

import { theme } from "../../configuration";

const Button = styled.button`
  padding: ${props => props.small ? `2px 4px 2px 4px` : `10px`};
  width: ${props => !props.small && `180px`};
  cursor: pointer;
  background-color: ${props => props.danger ? theme.colours.alertBackground : `#ffffff`};
  border: 1px solid ${theme.colours.border};
  border-radius: 4px;
  font-size: ${props => props.small && `0.8em`};
  
  background-color: ${props => props.working ? theme.colours.emphasis : '#ffffff'}
  
  :hover {
    background-color: ${theme.colours.border};
  }
 
   @media (min-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    font-size: 1.4em;
  }
  
`;

export default Button;

